import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchAgreementReportData } from "../../redux/reducers/apiSlice";
import { selectAuth } from "../auth/auth.selector";
import PaymentLinkTable from "../payment-link-system/PaymentLinkTable";
import ReactVortoxSpinner from "../common-components/ReactVortoxSpinner";
import { SearchIcon } from "../../images/icons/website-icons";
import { fetchGymData } from "../../data/APIs";
import { Button } from "react-bootstrap";
import "../../styles/pt/pt-trials.css";
import { getAgreementTBColumns } from "./agreement-utils";
import AgreementReportMobile from "./agreementReportMobile";

const AgreementsReport = () => {
  const dispatch = useDispatch();
  const authData = useSelector(selectAuth);
  const userInfoData = authData.user;

  console.log("User info data", userInfoData);

  const isAdmin = userInfoData?.account_type === "admin";
  const gymId = !isAdmin
    ? userInfoData?.gym_id || userInfoData?.user_id || userInfoData?.uid || ""
    : "";

  const [isPage, setIsPage] = useState(0);
  const [searchValue, setSearchValue] = useState("");
  const [pageLimit, setPageLimit] = useState(10);
  const iniFilters = {
    search: "",
    limit: pageLimit || 10,
    page: isPage + 1,
    gym_id: gymId || "",
  };
  const [filters, setFilters] = useState(iniFilters);

  const [showPassword, setShowPassword] = useState([]);

  const { error, loading, agreementReport } = useSelector((state) => state.api);

  const payload = {
    filters: filters,
    token: userInfoData?.token,
  };

  useEffect(() => {
    dispatch(fetchAgreementReportData(payload));
  }, [filters, isPage]);

  useEffect(() => {
    setFilters({
      ...filters,
      page: isPage + 1,
      limit: pageLimit,
      gym_id: gymId || "",
    });
  }, [isPage, pageLimit, gymId]);

  useEffect(() => {
    dispatch(fetchGymData(userInfoData?.token));
  }, [userInfoData]);

  useEffect(() => {
    if (searchValue.length === 0) {
      setFilters({
        ...filters,
        search: "",
      });
    }
  }, [searchValue]);

  const onClickSearch = () => {
    setIsPage(0);
    setFilters({
      ...filters,
      search: searchValue,
    });
  };

  const handleReset = () => {
    setFilters(iniFilters);
    setSearchValue("");
    setPageLimit(10);
  };

  const handleEyeOtp = (id) => {
    setShowPassword((prev) => {
      if (prev.includes(id)) {
        return prev.filter((item) => item !== id);
      } else {
        return [...prev, id];
      }
    });
  };

  if (error) {
    return <div>Something went wrong</div>;
  }

  return (
    <div className="agreement__Wrapper" style={{ padding: "0 20px" }}>
      <h2 className="titleHead">Agreement Logs</h2>
      <br />
      <div className="cmnFilterStructureContainer ptTrackContainer">
        <div className="filterblock gridSpanTwo">
          <div className="filterHeadingNBtn">
            <h5 className="filterHeading">All Filters</h5>
            <Button variant="outline-danger" onClick={handleReset}>
              Reset Filter
            </Button>
          </div>

          <div className="filterblock grid__two ">
            <div
              className={`inputCommonWrapper flexSpacebetween searchBarContainer `}
            >
              <input
                type="search"
                className="input"
                placeholder="Search by mobile, name"
                value={searchValue}
                onChange={(e) => setSearchValue(e.target.value)}
              />
              <button type="button" className="button" onClick={onClickSearch}>
                search
                <SearchIcon />
              </button>
            </div>
          </div>
        </div>
      </div>
      <br />

      <div>
        <div className="fullWidthFlexCenter overflowAuto separatedTable hideMobile no-border-table">
          {loading ? (
            <ReactVortoxSpinner />
          ) : (
            <PaymentLinkTable
              tableColumns={getAgreementTBColumns(showPassword, handleEyeOtp)}
              tableData={agreementReport?.data}
              tablePagination={agreementReport?.pagination}
              isPage={isPage}
              setIsPage={(value) => setIsPage(value)}
              setPageLimit={setPageLimit}
              pageLimit={pageLimit}
            />
          )}
        </div>

        <div className="lead-logs-card-container only-mobile">
          {loading ? (
            <ReactVortoxSpinner />
          ) : (
            <AgreementReportMobile
              tableData={agreementReport?.data}
              isPage={isPage}
              setIsPage={(value) => setIsPage(value)}
              tablePagination={agreementReport?.pagination}
              setPageLimit={setPageLimit}
              pageLimit={pageLimit}
              showPassword={showPassword}
              handleEyeOtp={handleEyeOtp}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default AgreementsReport;
